if (!customElements.get("bundle-item-picker")) {
  class BundleItemPicker extends HTMLElement {
    constructor() {
      super();

      this.productFormId = this.dataset.productFormId;
      this.productForm = document.querySelector("#" + this.productFormId);
      this.submitBtn = this.productForm.querySelector("[type=submit]");
      this.modalDialog = this.closest('modal-dialog');
      this.modalOpener = document.querySelector("modal-opener[data-modal='#"+ this.modalDialog.id +"']");
      this.successIcon = this.modalOpener.querySelector(".success-icon");
      this.modalCloser = this.modalDialog.querySelector(".modal__close");
      this.formNotification = this.modalDialog.querySelector(".form-notification");

      this.submitBtnTextWrapper = this.submitBtn.querySelector(".single-add-to-cart-button--text");
      this.submitBtnText = this.submitBtnTextWrapper.textContent;
      this.submitBtnTextIncomplete = this.dataset.buttonIncompleteText;
      this.submitBtnIncompleteClass = 'outline';

      this.checkIfItemsSelected();

      this.submitBtn.addEventListener("click", (e) => {
        if (this.getAttribute("bundle-items-selected") != "true") {
          e.preventDefault();
          this.modalDialog.show();
          return false;
        }
      });

      this.modalCloser?.addEventListener("click", (e) => {
          this.modalDialog.hide();
      });

      this.totalCount = 0;
      this.productCount = parseFloat(this.getAttribute("data-product_count"));
      this.labels = this.querySelectorAll(".product-item-option");
      this.checkBoxes = this.querySelectorAll('input[type="checkbox"]');
      this.bundleUniqueIdentifier = this.getAttribute("data-bundle-unique-identifier");
      this.selectedItems = [];
      this.cartQuantities = {};

      try {
        this.variants = JSON.parse(this.querySelector("script").innerHTML);
      } catch (err) {
        this.variants = [];
      }

      if (this.variants.length) {
        this.setupEventListeners();
      }
    }

    connectedCallback() {
      document.addEventListener('cart:item-added', this.afterBundleAddedToCart);
      document.addEventListener('cart:bundle-removed', this.afterBundleAddedToCart);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:item-added', this.afterBundleAddedToCart);
      document.removeEventListener('cart:bundle-removed', this.afterBundleAddedToCart);
    }

    afterBundleAddedToCart = (event) => {
      this.refreshCartQuantities();
    }

    setupEventListeners() {
      this.checkBoxes.forEach((el) => {
        el.addEventListener(
          "change",
          debounce((event) => this.handleCheckboxTick(event.target), 100).bind(
            this
          )
        );
      });

      this.labels.forEach((el) => {
        el.querySelector(".product-item-option-plus").addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            this.addQuantity(e);
          }
        );
        el.querySelector(".product-item-option-minus").addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            this.removeQuantity(e);
          }
        );
      });

      this.refreshCartQuantities();
    }

    handleCheckboxTick(input) {
      const label = this.querySelector(
        `label[for="${input.getAttribute("id")}"]`
      );
      if (label.classList.contains("selected")) {
        return;
      }
      if (input.checked) {
        this.setFormItem(input);
      } else {
        // this.removeFormItem(input);
      }
    }

    async refreshCartQuantities() {
      try {
        const res = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        });
        const cart = await res.json();
        // Sum across all lines, since the same variant can appear in several lines (properties, bundles)
        this.cartQuantities = cart.items.reduce((acc, item) => {
          acc[item.variant_id] = (acc[item.variant_id] || 0) + item.quantity;
          return acc;
        }, {});
      } catch (err) {
        console.error('Could not load cart', err);
        this.cartQuantities = {};
      }
    }

    checkQuantityToAdd(variant, new_qty) {
      const inventory_limit = parseInt(variant.inventoryLimit || 0);
      const in_cart_qty = this.cartQuantities?.[variant?.id] || 0;
      const remaining = Math.max(0, (inventory_limit - in_cart_qty));
      if(new_qty > remaining){
        this.showFormNotification();
        return false;
      }
      this.removeFormNotification();
      return true;
    }

    addQuantity(e) {
        if (this.quantityReached) return;
        const label = e.target.closest(".product-item-option");
        const labelFor = label.getAttribute("for");
        const variant = this.variants.find(
          (v) =>
            v.id ==
            this.querySelector(
              'input[id="' + labelFor + '"]'
            ).getAttribute("data-variant")
        );

        let currentItem = this.selectedItems.find(item => item.inputId == labelFor);
        let new_qty = (currentItem?.count || 0) + 1;
        if( !this.checkQuantityToAdd(variant, new_qty) ) {
          return;
        }

        this.selectedItems.forEach((item) => {
          if (item.inputId == labelFor) {
            item.count++;
            label.querySelector(".product-item-option-count").innerHTML =
              item.count;

            this.querySelector("#" + item.inputId).checked = true;
            this.changeVariantQuantity(item);
          }
        });
        this.totalCount++;
        if (this.totalCount == this.productCount) {
          this.blockCheckboxes();
        }
    }

    removeQuantity(e) {
      const label = e.target.closest(".product-item-option");

      this.selectedItems.forEach((item) => {
        if (item.inputId == label.getAttribute("for")) {
          if (item.count > 1) {
            label.querySelector(".product-item-option-count").innerHTML =
              item.count - 1;
            this.querySelector("#" + item.inputId).checked = true;
          } else {
            this.querySelector("#" + item.inputId).checked = false;

            label.querySelector(".product-item-option-count").innerHTML = 1;
            label.querySelector(".product-item-option-controls").style.display =
              "none";
            this.querySelector(
              `.product-item-option[for="${item.inputId}"]`
            ).classList.remove("selected");
          }
          item.count--;
          this.changeVariantQuantity(item);
        }
      });

      this.selectedItems = this.selectedItems.filter((item) => item.count > 0);

      this.totalCount--;
      if (this.totalCount < this.productCount) {
        this.unblockCheckboxes();
      }
    }

    setFormItem(input) {
      const label = this.querySelector(`.product-item-option[for="${input.getAttribute("id")}"]`);
      const variant = this.variants.find(
        (v) => v.id == input.getAttribute("data-variant")
      );
      if( !this.checkQuantityToAdd(variant, 1) ) {
        input.checked = false;
        label.classList.remove("selected");
        return;
      }

      let masterPos = variant.id;
      this.addVariantToBundle(variant, masterPos);
      this.selectedItems.push({
        inputId: input.id,
        position: masterPos,
        count: 1,
        ...variant,
      });
      this.totalCount++;
      label.classList.add("selected");
      label.querySelector(".product-item-option-controls").style.display = "flex";
      if (this.totalCount == this.productCount) {
        this.blockCheckboxes();
      }
    }

    addVariantToBundle(variant, masterPos) {
      this.insertAdjacentHTML(
        "beforeend",
        `
        <input form="${this.productFormId}" type="hidden" name="items[${masterPos}]properties[_bundle_unique_identifier]" value="${this.bundleUniqueIdentifier}">
        <input form="${this.productFormId}" type="hidden" name="items[${masterPos}]properties[_bundle_master_position]" value="${masterPos}">
        <input form="${this.productFormId}" type="hidden" name="items[${masterPos}]properties[_line_item_type]" value="bundle_select_item">
        <input form="${this.productFormId}" type="hidden" name="items[${masterPos}]id" value="${variant.id}">
        <input form="${this.productFormId}" type="hidden" name="items[${masterPos}]quantity" value="1">
        `
      );
    }

    changeVariantQuantity(item){
      if(item.count < 1){
        this.querySelectorAll(
          `input[name*="items\[${item.position}\]"]`
        ).forEach((el) => el.remove());  
      } else {
        this.querySelector(`input[name="items\[${item.position}\]quantity"]`).value = item.count;
      }
    }

    removeFormItem(input) {
      const selectedItem = this.selectedItems.find(
        (item) => item.id == input.getAttribute("data-variant")
      );
      selectedItem.count--;
      this.changeVariantQuantity(selectedItem);
      
      this.querySelector(
        `.product-item-option[for="${input.getAttribute("id")}"]`
      ).classList.remove("selected");
      this.selectedItems = this.selectedItems.filter(
        (item) => item.id != input.getAttribute("data-variant")
      );
      if (this.selectedItems.length <= this.productCount) {
        this.unblockCheckboxes();
      }
    }

    blockCheckboxes() {
      this.quantityReached = true;
      this.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        if (!input.checked) {
          input.setAttribute("disabled", "");
        }
      });
      this.setAttribute("bundle-items-selected", true);
      this.checkIfItemsSelected();
    }

    unblockCheckboxes() {
      this.quantityReached = false;
      this.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        if (input.hasAttribute("disabled")) {
          input.removeAttribute("disabled");
        }
      });
      this.setAttribute("bundle-items-selected", false);
      this.checkIfItemsSelected();
    }

    checkIfItemsSelected() {
      if(this.getAttribute("bundle-items-selected") == "true") {
        this.successIcon.classList.remove("hidden");
        this.modalCloser.removeAttribute("disabled");
        this.modalDialog.querySelector(".product-popup-modal__content-footer")?.classList.remove("hidden");
        this.submitBtn.classList.remove(this.submitBtnIncompleteClass);
        this.submitBtnTextWrapper.textContent = this.submitBtnText;
      } else {
        this.successIcon.classList.add("hidden");
        this.modalDialog.querySelector(".product-popup-modal__content-footer")?.classList.add("hidden");
        this.modalCloser.setAttribute("disabled", "");
        this.submitBtn.classList.add(this.submitBtnIncompleteClass);
        this.submitBtnTextWrapper.textContent = this.submitBtnTextIncomplete;
      }
    }

    showFormNotification() {
      this.formNotification.classList.remove('hidden');
      clearTimeout(this.notificationTimeout);
      this.notificationTimeout = setTimeout(() => {
        this.formNotification.classList.add('hidden');
      }, 5000);
    }
    removeFormNotification() {
      this.formNotification.classList.add('hidden');
    }
  }

  customElements.define("bundle-item-picker", BundleItemPicker);
}
